/**
 * @module-isolated analytics-lab
 * Banner fijo: Lab no reemplaza métricas oficiales.
 */
export default function LabBanner({ pageLabel }) {
  return (
    <aside className="lab-banner" role="note">
      <strong>Vista experimental{pageLabel ? ` · ${pageLabel}` : ''}</strong>
      <span>
        Inspirada en LeadTrack. No reemplaza las métricas oficiales del menú superior. Los
        números de Resumen / Leads / Marketing siguen siendo la referencia GI.
      </span>
    </aside>
  );
}
